import type { Listing } from 'app/types/listing';
import type { ListingsVisibilityExclusionsPreference } from 'app/screens/new';

export function getConciergeVisibility(
  addresses: { id: string }[],
  groups: { id: string; subtype?: string | null }[],
  exclusions: ListingsVisibilityExclusionsPreference | null,
) {
  const excludedAddresses = new Set(
    exclusions?.addressIds ?? (groups.some((g) => g.subtype === 'municipal_closed') ? addresses.map((a) => a.id) : []),
  );
  const excludedGroups = new Set(exclusions?.groupIds);
  return {
    addressIds: addresses.flatMap((a) => (excludedAddresses.has(a.id) ? [] : [a.id])),
    groupIds: groups.flatMap((g) => (excludedGroups.has(g.id) ? [] : [g.id])),
  };
}

export function getGroupedLenderCount(listing: Listing) {
  const members = listing.grouping?.listings;
  if (!members?.length) return undefined;
  const count = new Set(members.map((offer) => offer.user.id)).size;
  // totalOffers counts listings, not people. A truncated response only gives
  // a lower bound on unique owners; don't present it as an exact lender count.
  const isLowerBound = (listing.grouping?.totalOffers ?? members.length) > members.length;
  return { count, label: count > 99 ? '99+' : String(count) + (isLowerBound ? '+' : '') };
}
